const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the Explore People Search Directive which displays and handles loading and infinite scrolling for searching users
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('explorePeopleSearch', ['Authorization', 'Users', 'Categories', 'i18n', function (Authorization, Users, Categories, i18n) {
    return {
      restrict: 'E',
      scope: {
        loading: '=',
        onSearch: '=',
        peopleView: '='
      },
      template: require('../../templates/directives/explore-people-search.html'),
      controller: ['$scope', '$window', function ($scope, $window) {
          var self = this;
          self.categoryDirectory = {};
          self.categoryInit = false;
          self.categoryRequest = false;
          self.user = Authorization.getAuthToken().user;
          self.users = [];
          self.per_page = 24;
          self.query = {};
          self.disableScroll;
          self.endOfLine;
          self.loading = true;
          self.initalLoad = false;

          self.profiles = {
            active: false,
            user: null,
            viewUser: function(user) {
              if (!user) {
                return;
              }
              this.user = user;
              this.active = true;
              $scope.$emit('updateFullScreen', true);
            },
            onExit: function() {
              this.active = false;
              $scope.$emit('updateFullScreen', false);
            }
          };

          $scope.onSearch = function(opts) {
            self.refresh();
            self.query.sort = 'last_name,1';
            if (!opts) {
              self.load();
              return;
            }

            for (var key in opts) {
              self.query[key] = opts[key];
            }

            self.load();
          };

          self.refresh = function () {
            self.users = [];
            self.disableScroll = true;
            self.endOfLine = false;

            self.query = {
              page: 1,
              per_page: self.per_page,
              last_login: '$exists,true',
              fields: 'first_name,last_name,full_name,email,image,role,linked_departments,linked_teams,linked_org_levels,linked_grades,linked_locations,skills,job_title,last_login',
              'skills-populate': 'name'
            };
          };

          self.load = function() {
            if (self.initalLoad && self.loading) {
              return;
            };
            self.initalLoad = true;
            self.loading = true;
            Users.find(self.query).$promise.then(function (list) {
              list.forEach(function(user) {
                self.getSegData(user);
                if (user.skills && user.skills.length && user.skills.length > 2) {
                  var more = user.skills.length - 2;
                  user.skills.splice(2);
                  user.skills.push({_id: '007',name: '+ ' + more});
                }
              });
              self.users = self.users.concat(list);
              self.query.page++;
              self.loading = false;
              if (list.length < self.per_page) {
                self.disableScroll = true;
                self.endOfLine = true;
                return;
              }
              self.disableScroll = false;
            });
          };

          self.getSegData = function(user) {
            self.categoryRequest = true;
            user.locationName = '';
            user.departmentName = '';

            if (!self.categoryInit) {
              return;
            }
            if (user.linked_locations && user.linked_locations.length && self.categoryDirectory && self.categoryDirectory[user.linked_locations[0]]) {
              user.locationName = self.categoryDirectory[user.linked_locations[0]] || '';
            }

            if (user.linked_departments && user.linked_departments.length && self.categoryDirectory && self.categoryDirectory[user.linked_departments[0]]) {
              user.departmentName = self.categoryDirectory[user.linked_departments[0]] || '';
            }
          };

          self.initialize = function () {
            Categories.find({$or: '10,location,true,department,true,team,true,org_level,true,grade,true', fields: 'location,department,team,org_level,grade,name,localized_names'}).$promise.then(function(cats) {
              cats = i18n.localize_categories(cats);
              cats.forEach(function(cat) {
                self.categoryDirectory[cat._id] = cat.name;
              });
              self.categoryInit = true;
              if (self.categoryRequest) {
                self.users.forEach(function(user) {
                  self.getSegData(user);
                });
              }
            });

            self.refresh();
            self.query.sort = 'last_name,1';
            self.load();
          };

          self.updateWindowHeight = function() {
            let exploreTopBarHeight = 0;
            let logoTopBarHeight = 0;
            if (document.querySelector('explore-topbar')) {
              exploreTopBarHeight = document.querySelector('explore-topbar').clientHeight;
            }
            if (document.querySelector('.topbar__logo')) {
              logoTopBarHeight = document.querySelector('.topbar__logo').clientHeight;
            }
            self.windowHeight = $window.innerHeight - (exploreTopBarHeight + logoTopBarHeight);
          }

          angular.element($window).bind('resize', function() {
            self.updateWindowHeight();
            $scope.$apply();
          });

          $scope.$on('$destroy', function () {
            angular.element($window).unbind('resize');
          });

          self.updateWindowHeight();
          setTimeout (() => {
            self.updateWindowHeight();
            $scope.$apply();
          }, 50);
          self.initialize();
        }],
      controllerAs: 'peoplesearch'
    };
  }]);
